import React, { PureComponent, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Settings } from 'react-slick';
import { Button } from 'lego-on-react';
import b from 'b_';

import './entities-block.css';

import ContentBlock from '@components/content-block';
import ArrowLink from '@components/arrow-link';
import EntitiesCarousel from '@components/entities-carousel';

interface Props {
    title: string;
    description?: string;
    className?: string;
    arrowClass?: string;
    linkToAllEntities?: {
        url: string;
        text: string;
    };
    linkAsButton?: boolean;
    entities: any[];
    carouselConfig?: Settings;
    isDesktop?: boolean;
    renderItem(entity: any): ReactNode;
}

const LegoButton = Button as any;
const class_ = b.with('entities-block');

export default class EntitiesBlock extends PureComponent<Props> {
    public renderLinkButton() {
        const { linkToAllEntities } = this.props;
        const { url, text } = linkToAllEntities || ({} as any);

        return (
            <LegoButton
                theme="action"
                type="link"
                size="l"
                cls={class_('link-button')}
                to={url}
            >
                {text}
            </LegoButton>
        );
    }

    /* tslint:disable-next-line cyclomatic-complexity */
    public renderCarousel() {
        const {
            carouselConfig, linkToAllEntities, entities, isDesktop, linkAsButton = false, arrowClass, renderItem
        } = this.props;

        return (
            <div className={class_('content')}>
                <EntitiesCarousel settings={carouselConfig}>
                    {entities.map(renderItem)}
                    {!isDesktop && !linkAsButton && Boolean(linkToAllEntities) &&
                        <ArrowLink className={arrowClass} {...(linkToAllEntities as any)} />
                    }
                </EntitiesCarousel>
                {linkAsButton && Boolean(linkToAllEntities) &&
                    this.renderLinkButton()
                }
            </div>
        );
    }

    public render() {
        const { className = '', description, linkToAllEntities, title, linkAsButton = false, isDesktop } = this.props;
        const { url, text } = linkToAllEntities || ({} as any);

        const top = !linkAsButton && isDesktop && Boolean(url) && (
            <Link to={url} className="block__title-link">
                {text}
            </Link>
        );

        return (
            <ContentBlock
                className={`${class_()} ${className}`}
                title={title}
                description={description}
                top={top}
                content={this.renderCarousel()}
            />
        );
    }
}
